import React from 'react';
import PropTypes from 'prop-types';
import Toggle from '../toggle/Toggle';

export default class OptionFilters extends React.PureComponent {
  onChange = (filter, value) => {
    const {values, onChange} = this.props;

    onChange({...values, [filter]: parseInt(value) || undefined});
  };

  render() {
    const {filters, values} = this.props;

    return (
      <React.Fragment>
        {filters.map(filter => (
          <Toggle
            key={filter.id}
            small
            leftLabel={filter.values[0].value}
            rightLabel={filter.values[1].value}
            isToggled={values[filter.id] === filter.values[1].id}
            onToggle={isToggled => this.onChange(filter.id, filter.values[isToggled ? 1 : 0].id)}
          />
        ))}
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./components/optionFilters/OptionFilters.js